import { render, staticRenderFns } from "./VideoHelpModal.vue?vue&type=template&id=37c9c8fa&scoped=true&"
import script from "./VideoHelpModal.vue?vue&type=script&lang=js&"
export * from "./VideoHelpModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoHelpModal.vue?vue&type=style&index=0&id=37c9c8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9c8fa",
  null
  
)

export default component.exports